export enum RegisterSteps {
    Step1 = 'step-1',
    Step2 = 'step-2',
    Step3 = 'step-3',
    Step4 = 'step-4',
    Step5 = 'step-5'
}